import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { Sparkles } from 'lucide-react';
import { TourSection } from './welcomeTourData';

interface WelcomeTourSidebarProps {
  sections: TourSection[];
  activeSectionId: string;
  onSelectSection: (id: string) => void;
}

const WelcomeTourSidebar: FC<WelcomeTourSidebarProps> = ({
  sections,
  activeSectionId,
  onSelectSection,
}) => {
  const { t } = useTranslation('welcomeTour');

  return (
    <div className="w-52 shrink-0 border-r border-zinc-200 dark:border-zinc-700 bg-white dark:bg-zinc-900 rounded-l-xl flex flex-col">
      <div className="px-4 pt-4 pb-2">
        <div className="flex items-center gap-2 mb-0.5">
          <Sparkles className="h-4 w-4 text-amber-500" />
          <h2 className="text-sm font-semibold text-zinc-900 dark:text-white">
            {t('TOUR_SIDEBAR_TITLE')}
          </h2>
        </div>
        <p className="text-xs text-zinc-500 dark:text-zinc-400">
          {t('TOUR_SIDEBAR_SUBTITLE')}
        </p>
      </div>

      <nav className="flex-1 overflow-y-auto px-2 pb-3">
        {sections.map((section) => {
          const Icon = section.icon;
          const isActive = section.id === activeSectionId;

          return (
            <button
              key={section.id}
              onClick={() => onSelectSection(section.id)}
              className={clsx(
                'flex items-center gap-2 w-full px-2.5 py-1.5 rounded-lg text-left',
                'text-sm transition-colors mb-0.5',
                isActive
                  ? 'bg-blue-600 text-white font-medium'
                  : 'text-zinc-700 hover:bg-zinc-100 dark:text-zinc-300 dark:hover:bg-zinc-800'
              )}
            >
              <Icon className={clsx(
                'h-4 w-4 shrink-0',
                isActive ? 'text-white' : 'text-zinc-400 dark:text-zinc-500'
              )} />
              <span className="truncate">{t(section.nameKey)}</span>
              {isActive && (
                <span className="ml-auto text-white/80">
                  <svg className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z" clipRule="evenodd" />
                  </svg>
                </span>
              )}
            </button>
          );
        })}
      </nav>
    </div>
  );
};

export default WelcomeTourSidebar;
